import type { IconBaseProps } from "./Icon";

export default function ResetIcon({ className, color, width, height }: IconBaseProps) {
  return (
    <svg
      className={className}
      style={{ color: color }}
      width={width ?? 21}
      height={height ?? 21}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Reset</title>
      <path
        d="M3.578 6.98732C4.55072 5.30853 6.1004 4.04046 7.93848 3.41922C9.77657 2.79798 11.7778 2.8659 13.5695 3.61035C15.3613 4.3548 16.8214 5.72504 17.678 7.46592C18.5347 9.2068 18.7294 11.1997 18.2261 13.0735C17.7227 14.9473 16.5556 16.5743 14.9419 17.6516C13.3282 18.7289 11.378 19.183 9.45441 18.9294C7.53082 18.6758 5.76494 17.7318 4.48557 16.2731C3.20621 14.8145 2.50055 12.9406 2.5 11.0003"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.5 7H3.5V3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
